import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllLevyTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.LevyTypeAPI}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getLevyTypeById = async ({ companyCode,code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.LevyTypeAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertLevyType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.LevyTypeAPI, input);
  return data;
};

const updateLevyType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.LevyTypeAPI, input);
  return data;
};

const deleteLevyType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.LevyTypeAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetLevyTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.LevyTypeAPI],
    queryFn: () => getAllLevyTypes(input),
    // refetchOnWindowFocus: false,
  });
};

export const useGetLevyTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.LevyTypeAPI],
    queryFn: () => getLevyTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertLevyTypeMutation = () => {
  return useMutation({
    mutationFn: insertLevyType,
  });
};

export const useUpdateLevyTypeMutation = () => {
  return useMutation({
    mutationFn: updateLevyType,
  });
};

export const useDeleteLevyTypeMutation = () => {
  return useMutation({
    mutationFn: deleteLevyType,
  });
};
